import LecturesIcon from '../assets/lectureIcon.svg'
import QuestionsIcon from '../assets/questionsIcon.svg'
import WorkShopIcon from '../assets/workshopIcon.svg'

export const DSAWhatYouGetSectionData = [
  {
    icon: LecturesIcon.src,
    count: '50+ hours',
    heading: 'of video exploration'
  },
  {
    icon: QuestionsIcon.src,
    count: '200+',
    heading: 'Questions'
  },
  {
    icon: WorkShopIcon.src,
    count: '4+',
    heading: 'Skill Workshops'
  }
]

export const FrontendWhatYouGetSectionData = [
  {
    icon: LecturesIcon.src,
    count: '150+ hours',
    heading: 'of video exploration'
  },
  {
    icon: QuestionsIcon.src,
    count: '250+',
    heading: 'questions to build components'
  },
  {
    icon: WorkShopIcon.src,
    count: '10+',
    heading: 'Projects'
  }
]

export const BackendWhatYouGetSectionData = [
  {
    icon: LecturesIcon.src,
    count: '150+ hours',
    heading: 'of video exploration'
  },
  {
    icon: QuestionsIcon.src,
    count: '250+',
    heading: 'questions to build components'
  },
  {
    icon: WorkShopIcon.src,
    count: '10+',
    heading: 'Projects'
  }
]

export const WhatYouGetSectionData: {
  [key: string]: {
    icon: string
    count: string
    heading: string
  }[]
} = {
  dsa: DSAWhatYouGetSectionData,
  frontend: FrontendWhatYouGetSectionData,
  backend: BackendWhatYouGetSectionData
}
